import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const {persistAtom} = recoilPersist({
    key: "teacherIdState",
    storage:sessionStorage, //sessionStorage사용
})

// 1️⃣ `teacherId`를 저장하는 atom
export const teacherIdState = atom({
    key: "teacherIdState",
    default: null,
    effects_UNSTABLE: [persistAtom]
});

export const teacherNameState = atom( {
    key: "teacherNameState",
    default: null
});

export const schoolNameState = atom( {
    key: "schoolNameState",
    default: null,
    effects_UNSTABLE: [persistAtom]
});

export const teacherGradeState = atom( {
    key: "teacherGradeState",
    default: null,
    effects_UNSTABLE: [persistAtom]
});

export const teacherSemesterState = atom( {
    key: "teacherSemesterState",
    default: null,
    effects_UNSTABLE: [persistAtom]
});